import go from 'gojs';

//############# shape template ##############//
function initializeShapes() {
    go.Shape.defineFigureGenerator("RoundedTopRectangle", function (shape, w, h) {
        // this figure takes one parameter, the size of the corner
        var p1 = 5; // default corner size
        if (shape != null) {
            var param1 = shape.parameter1;
            if (!isNaN(param1) && param1 >= 0) p1 = param1;
        }
        p1 = Math.min(p1, w / 2);
        p1 = Math.min(p1, h / 2); // limit by whole height or by half height?
        var geo = new go.Geometry();
        // a single figure consisting of straight lines and quarter-circle arcs
        geo.add(new go.PathFigure(0, p1)
            .add(new go.PathSegment(go.PathSegment.Arc, 180, 90, p1, p1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, w - p1, 0))
            .add(new go.PathSegment(go.PathSegment.Arc, 270, 90, w - p1, p1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, w, h))
            .add(new go.PathSegment(go.PathSegment.Line, 0, h).close()));
        // don't intersect with two top corners when used in an "Auto" Panel
        geo.spot1 = new go.Spot(0, 0, 0.3 * p1, 0.3 * p1);
        geo.spot2 = new go.Spot(1, 1, -0.3 * p1, 0);
        return geo;
    });

    go.Shape.defineFigureGenerator("WarningItem", function (shape, w, h) {
        var p1 = 9; // default corner size
        h -= 1;
        var geo = new go.Geometry();
        geo.add(new go.PathFigure(0, p1)
            .add(new go.PathSegment(go.PathSegment.Arc, 180, 90, p1, p1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, w - p1, 0))
            .add(new go.PathSegment(go.PathSegment.Arc, 270, 90, w - p1, p1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, w, h - p1 + 1))
            .add(new go.PathSegment(go.PathSegment.Arc, 0, 90, w - p1, h - p1 + 1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, p1, h + 1))
            .add(new go.PathSegment(go.PathSegment.Arc, 90, 90, p1, h - p1 + 1, p1, p1).close()));
        geo.spot1 = new go.Spot(0, 0, 0.3 * p1, 0.3 * p1);
        geo.spot2 = new go.Spot(1, 1, -0.3 * p1, 0);
        return geo;
    });

    go.Shape.defineFigureGenerator("TopButton", function (shape, w, h) {
        var p1 = 2; // default corner size
        var geo = new go.Geometry();
        geo.add(new go.PathFigure(0, p1)
            .add(new go.PathSegment(go.PathSegment.Arc, 180, 90, p1, p1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, w - p1, 0))
            .add(new go.PathSegment(go.PathSegment.Arc, 270, 90, w - p1, p1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, w, h - p1))
            .add(new go.PathSegment(go.PathSegment.Arc, 0, 90, w - p1, h - p1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, p1, h))
            .add(new go.PathSegment(go.PathSegment.Arc, 90, 90, p1, h - p1, p1, p1).close()));
        geo.spot1 = new go.Spot(0, 0, 0.3 * p1, 0.3 * p1);
        geo.spot2 = new go.Spot(1, 1, -0.3 * p1, 0);
        return geo;
    });

    go.Shape.defineFigureGenerator("SelectionRectangle", function (shape, w, h) {
        var p1 = 3; // default corner size
        var correction = p1 / 4;
        var geo = new go.Geometry();
        geo.add(new go.PathFigure(correction, p1)
            .add(new go.PathSegment(go.PathSegment.Arc, 180, 90, p1 + correction, p1 + correction, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, w - p1 - correction, correction))
            .add(new go.PathSegment(go.PathSegment.Arc, 270, 90, w - p1 - correction, p1 + correction, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, w - correction, h - p1 - correction))
            .add(new go.PathSegment(go.PathSegment.Arc, 0, 90, w - p1 - correction, h - p1, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, p1 + correction, h))
            .add(new go.PathSegment(go.PathSegment.Arc, 90, 90, p1 + correction, h - p1, p1, p1).close()));
        geo.spot1 = new go.Spot(0, 0, 0.3 * p1, 0.3 * p1);
        geo.spot2 = new go.Spot(1, 1, -0.3 * p1, 0);
        return geo;
    });

    go.Shape.defineFigureGenerator("NodeGlow", function (shape, w, h) {
        var p1 = 10; // default corner size
        if (shape != null) {
            var param1 = shape.parameter1;
            if (!isNaN(param1) && param1 >= 0) p1 = param1;
        }
        // correction to move glow a bit away from target frame
        p1 = p1 * 1.35;
        var luCorner = new go.Point(-(p1 / 2), -(p1 / 2));
        var ruCorner = new go.Point(w + (p1 / 2), -(p1 / 2));
        var rlCorner = new go.Point(w + (p1 / 2), h + (p1 / 2));
        var lrCorner = new go.Point(-(p1 / 2), h + (p1 / 2));

        var geo = new go.Geometry();
        geo.add(new go.PathFigure(luCorner.x - p1, luCorner.y)
            .add(new go.PathSegment(go.PathSegment.Arc, 180, 90, luCorner.x, luCorner.y, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, ruCorner.x, ruCorner.y - p1))
            .add(new go.PathSegment(go.PathSegment.Arc, 270, 90, ruCorner.x, ruCorner.y, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, rlCorner.x + p1, rlCorner.y))
            .add(new go.PathSegment(go.PathSegment.Arc, 0, 90, rlCorner.x, rlCorner.y, p1, p1))
            .add(new go.PathSegment(go.PathSegment.Line, lrCorner.x, lrCorner.y + p1))
            .add(new go.PathSegment(go.PathSegment.Arc, 90, 90, lrCorner.x, lrCorner.y, p1, p1).close()));
        geo.spot1 = new go.Spot(0, 0, 0.3 * p1, 0.3 * p1);
        geo.spot2 = new go.Spot(1, 1, -0.3 * p1, 0);
        return geo;
    });
}

export { initializeShapes };
